<template>
    <div class="my-5">
        <h3>Prestazioni</h3>
        <div v-for="(input, index) in inputs" :key="index">
            <div class="row align-items-center single-quote-service">
                <div class="col-auto bg-light">
                    {{ (index+1) }}
                </div>
                <div class="col">
                    <select-item
                            :name="'quote_services[' + index + '][service]'"
                            v-model="inputs[index].service"
                            @input="setServiceData(index)"
                            action="/services/list"
                            item-value="id"
                            item-text="namePriceSupplier"
                            :return-object="true"
                            :clearable="true"
                            :label="serviceLabel"
                            :cache-items="false"
                        ></select-item>
                        <div class="row">
                            <div class="col-12">
                                <v-textarea :name="'quote_services[' + index + '][description]'" :label="descriptionLabel" rows="1"
                                    v-model="inputs[index].description">
                                </v-textarea>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][um]'" v-model="inputs[index].um" :label="umLabel"
                                    type="text">
                                </v-text-field>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][quantity]'" v-model="inputs[index].quantity" :label="quantityLabel"
                                    @change="updateServiceQty(index)"
                                    type="number">
                                </v-text-field>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][single_price]'" v-model="inputs[index].single_price" :label="priceLabel"
                                    @change="updateServicePrice(index)"
                                    type="number">
                                </v-text-field>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][total]'" v-model="inputs[index].total" :label="totalLabel"
                                    readonly
                                    type="number">
                                </v-text-field>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][total_cost]'" v-model="inputs[index].total_cost" :label="totalCostLabel"
                                    @change="updateServiceCost(index)"
                                    type="number">
                                </v-text-field>
                            </div>
                            <div class="col">
                                <v-text-field :name="'quote_services[' + index + '][margin]'" v-model="inputs[index].margin" :label="marginLabel"
                                    readonly
                                    type="number">
                                </v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-checkbox :name="'quote_services[' + index + '][schedule]'" value="1" true-value="1" false-value="0" v-model="inputs[index].schedule" :label="scheduleLabel"></v-checkbox>
                            </div>
                        </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-danger rounded-circle row-btn" type="button" @click="removeInput(index)">-</button> 
                </div>
            </div>
        </div>
        <div class="text-center">
            <button class="btn row-btn btn-info add-row" type="button" @click="addInput">+</button>
        </div>
        <div class="my-5 row">
            <div class="col-lg-4">
                <div class="shadow p-3">                 
                    <h3 class="mb-0">Totale preventivo: {{ getTotals.totalPrice }}€</h3>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="shadow p-3">                 
                    <h3 class="mb-0">Costo totale: {{ getTotals.totalCost }}€</h3>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="shadow p-3">                 
                    <h3 class="mb-0">Margine totale: {{ getTotals.totalMargin }}€</h3>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "QuoteServices",
    props: {
        value: {type: Array, default: [{
            description: '',
            um: '',
            quantity: 0,
            single_price: 0.00,
            total: 0.00,
            total_cost: 0.00,
            margin: 0.00,
            schedule: "1",
        }]},
        label:{default:'Prestazioni'},
        loading:{default:false},
        multiple:{default:false},
        disabled:{default:false},
        required:{default:false},
        name:{},
        rules:{},
        titleLabel: {default: 'Titolo'},
        descriptionLabel: {default: 'Descrizione'},
        serviceLabel: {default: 'Scegli prestazione o compila manualmente'},
        umLabel: {default: 'U.M.'},
        quantityLabel: {default: 'Qty'},
        priceLabel: {default: 'Importo'},
        totalLabel: {default: 'Totale parziale'},
        totalCostLabel: {default: 'Costo totale'},
        marginLabel: {default: 'Margine totale'},
        scheduleLabel: {default: 'Pianifica'},
    },
    computed: {
        inputs: {
            get() {
                if(!this.value) {
                    return [{
                        description: '',
                        um: '',
                        quantity: 0,
                        single_price: 0.00,
                        total: 0.00,
                        total_cost: 0.00,
                        margin: 0.00,
                        schedule: "1",
                    }];
                }else {
                    return this.value;
                }
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        getTotals() {
            var totalPrice = 0;
            var totalCost = 0;
            var totalMargin = 0;
            for (var i=0;i<this.inputs.length;i++) {
                totalPrice += parseFloat(this.inputs[i].total);
                totalCost += parseFloat(this.inputs[i].total_cost);
                totalMargin += parseFloat(this.inputs[i].margin);
            }
            return {
                totalPrice: totalPrice,
                totalCost: totalCost,
                totalMargin: totalMargin,
            }
        }
    },
    methods: {
        addInput() {
            this.inputs.push({
                service: null,
                description: '',
                um: '',
                quantity: 0,
                single_price: 0.00,
                total: 0.00,
                total_cost: 0.00,
                margin: 0.00,
                schedule: "1",
            });
            this.$emit('input', this.inputs);
        },

        removeInput(index) {
            this.inputs.splice(index, 1);
            this.$emit('input', this.inputs);
        },
        setServiceData(index) {
            if(this.inputs[index].service && !this.inputs[index].margin) {
                var service = this.inputs[index].service;
                this.inputs[index].description = service.namePriceSupplier;
                this.inputs[index].single_price = service.price;
                this.inputs[index].total = service.price*this.inputs[index].quantity;
                this.inputs[index].total_cost = service.price*this.inputs[index].quantity;
                this.inputs[index].margin = this.inputs[index].total - this.inputs[index].total_cost;
            }
            this.$emit('input', this.inputs);                
        },
        updateServiceQty(index) {
            this.inputs[index].total = this.inputs[index].single_price*this.inputs[index].quantity;
            this.inputs[index].total_cost = this.inputs[index].single_price*this.inputs[index].quantity;
            this.inputs[index].margin = this.inputs[index].total - this.inputs[index].total_cost;
            this.$emit('input', this.inputs);  
        },
        updateServicePrice(index) {
            this.inputs[index].total = this.inputs[index].single_price*this.inputs[index].quantity;
            this.inputs[index].margin = this.inputs[index].total - this.inputs[index].total_cost;
            this.$emit('input', this.inputs);  
        },
        updateServiceCost(index) {
            this.inputs[index].margin = this.inputs[index].total - this.inputs[index].total_cost;
            this.$emit('input', this.inputs);  
        }
    },
};
</script>